import { Box, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React from "react";

const FooterContainer = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.secondary,
  },
}))(Box);

export default function Footer() {
  return (
    <FooterContainer py={1}>
      <Typography align="center" variant="body2">
        Copyright © {new Date().getFullYear()}. All Rights Reserved By Trava.Finance
      </Typography>
    </FooterContainer>
  );
}
